import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 14 15" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.6 3.5c0-.387-.312-.7-.697-.7a.703.703 0 0 1-.703.7c-.387 0-.7-.31-.7-.7H9.1c0 .387-.31.7-.7.7-.387 0-.7-.31-.7-.7H6.3c0 .387-.31.7-.7.7-.387 0-.7-.31-.7-.7H3.5c0 .387-.31.7-.7.7-.387 0-.7-.31-.7-.7-.388 0-.7.313-.7.7v1.4h11.2V3.5zM1.4 6.3v6.3c0 .387.312.7.697.7h9.806a.698.698 0 0 0 .697-.7V6.3H1.4zM14 3.5v9.1c0 1.16-.938 2.1-2.097 2.1H2.097A2.099 2.099 0 0 1 0 12.6V3.5c0-1.16.938-2.1 2.097-2.1L2.1.7c0-.387.31-.7.7-.7.387 0 .7.31.7.7v.7h1.4V.7c0-.387.31-.7.7-.7.387 0 .7.31.7.7v.7h1.4V.7c0-.387.31-.7.7-.7.387 0 .7.31.7.7v.7h1.4V.7c0-.387.31-.7.7-.7.387 0 .7.31.7.7v.7A2.1 2.1 0 0 1 14 3.5z" fill={color} fillRule="evenodd" />
    </svg>
)

export default class IconCalendarSimple extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
